import { render } from "./CreateArea.vue?vue&type=template&id=0310de8b&scoped=true"
import script from "./CreateArea.vue?vue&type=script&lang=js"
export * from "./CreateArea.vue?vue&type=script&lang=js"

import "./CreateArea.vue?vue&type=style&index=0&id=0310de8b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0310de8b"]])

export default __exports__